import { Controller } from "stimulus"
import Trix from "trix"

const ACCEPTED_CONTENT_TYPES = [
  "application/pdf",
  "image/bmp",
  "image/gif",
  "image/heic",
  "image/heif",
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/tiff",
  "image/webp",
  "image/x-ms-bmp"
];

const FILE_PICKER_ACCEPT = "image/*,application/pdf";

export default class extends Controller {
  connect() {
    this.configureFilePicker();

    const form = this;
    const submitButton = form.element.querySelector('input[type=submit]');
    const trixeditor = this.element.querySelector('trix-editor');
    if (!trixeditor) return;

    trixeditor.addEventListener("trix-file-accept", event => {
      if (this.acceptedFile(event.file)) return;

      event.preventDefault();
      window.alert("Seuls les fichiers image et les PDF sont autorises.");
    });

    if ((window.innerWidth >= 576 ))  {
      console.log(form);
      trixeditor.addEventListener("keydown", event => {
        if (document.querySelector('[data-trix-active]') === document.querySelector('[data-trix-attribute="bullet"]') || document.querySelector('[data-trix-active]') === document.querySelector('[data-trix-attribute="number"]')) {
          if (event.shiftKey && event.key == "Enter") {
            event.target.editor.recordUndoEntry('Shift+Enter');
            event.target.editor.insertLineBreak();
            event.preventDefault();
          }
        }
        if (event.keyCode == 13 && !event.shiftKey) {
          event.preventDefault();
          if (form.element.querySelector('.remote-true') && form.element.querySelector('.remote-true') === submitButton) {
            Rails.fire(trixeditor.inputElement.form, 'submit')
          } else {
            submitButton.click();
          }
        }
      })
    }
  }

  disconnect() {
    const controllerClass = this.constructor;
    controllerClass.instanceCount = Math.max((controllerClass.instanceCount || 1) - 1, 0);

    if (controllerClass.instanceCount === 0 && controllerClass.originalPickFiles && Trix?.config?.input) {
      Trix.config.input.pickFiles = controllerClass.originalPickFiles;
      controllerClass.originalPickFiles = null;
    }
  }

  configureFilePicker() {
    const controllerClass = this.constructor;
    controllerClass.instanceCount = (controllerClass.instanceCount || 0) + 1;

    if (!Trix?.config?.input || controllerClass.originalPickFiles) return;

    controllerClass.originalPickFiles = Trix.config.input.pickFiles;

    Trix.config.input.pickFiles = callback => {
      const fileInput = document.createElement("input");
      const existingInput = document.getElementById(Trix.config.input.fileInputId);

      if (existingInput) {
        existingInput.remove();
      }

      fileInput.type = "file";
      fileInput.multiple = true;
      fileInput.hidden = true;
      fileInput.accept = FILE_PICKER_ACCEPT;
      fileInput.id = Trix.config.input.fileInputId;
      fileInput.addEventListener("change", () => {
        callback(fileInput.files);
        fileInput.remove();
      });

      document.body.appendChild(fileInput);
      fileInput.click();
    };
  }

  acceptedFile(file) {
    const filenameParts = (file.name || "").toLowerCase().split(".");
    const hasSingleExtension = filenameParts.length <= 2;

    return hasSingleExtension && ACCEPTED_CONTENT_TYPES.includes(file.type);
  }
}
